<template>
    <a-card :bordered="false">
        <div class="table-page-search-wrapper">
        </div>
        <div class="table-operator">
            <a-button type="primary" icon="plus" @click="handleAdd">新建</a-button>
        </div>
        <template>
            <a-table ref="table"
                     :columns="columns"
                     rowKey="id"
                     :dataSource="treeList"
            >
        <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical"/>
          <a @click="handleAdd(record)">新增子分类</a>
          <a-divider type="vertical"/>
            <a-popconfirm title="确定删除分类吗" @confirm="deleteCate(record)" okText="确定" cancelText="取消">
    <a href="javascript:;">删除</a>

        </a-popconfirm>
        </template>
      </span>
                <span slot="name" slot-scope="name,record">
          <span v-if="record.status==1">{{record.name}}</span>
          <span v-else style="color: #999">{{record.name}}</span>
          <div v-if="record.name_en" style="color:#999;font-size:12px;line-height:1.4;">{{record.name_en}}</div>
      </span>
                <span slot="status" slot-scope="status,record">
        <a-badge status="success" v-if="status==1" text="显示"/>
        <a-badge status="default" v-else text="隐藏"/>
      </span>

                <span slot="rank" slot-scope="text,record">
        <template>
        <editable-cell :text="text" @change="onRankChange(record.id, 'rank', $event)"/>
        </template>
      </span>


            </a-table>
        </template>
        <a-modal
        :maskClosable="false"
                title="操作"
                :width="800"
                v-model="visible"
                @ok="handleOk"
        >
            <a-spin :spinning="saveLoading">
                <a-form :form="form">
                    <a-form-item
                            :labelCol="labelCol"
                            :wrapperCol="wrapperCol"
                            label="上级分类"
                            v-if="!formData.id"
                            hasFeedback
                    >
                        <a-cascader :options="options"
                                    placeholder="顶级分类"
                                    changeOnSelect
                                    v-model="formData.parents_ids"
                                    :fieldNames="{ label: 'title', value: 'key', children: 'children' }"
                        />
                    </a-form-item>

                    <a-form-item
                            :labelCol="labelCol"
                            :wrapperCol="wrapperCol"
                            label="名称"
                            hasFeedback
                    >
                        <a-input v-decorator="[
          'name',
          {rules: [{ required: true, message: '请输入分类名称' }]}
        ]"
                                 placeholder="请输入分类名称（中文）"/>
                    </a-form-item>

                    <a-form-item
                            :labelCol="labelCol"
                            :wrapperCol="wrapperCol"
                            label="英文名称"
                            hasFeedback
                    >
                        <a-input v-decorator="['name_en']"
                                 placeholder="English name"/>
                    </a-form-item>

                            <a-form-item
                              :labelCol="labelCol"
                              :wrapperCol="wrapperCol"
                              label="副标题"
                              hasFeedback
                            >
                              <a-input v-decorator="[
                              'sname',

                            ]"
                             placeholder="分类栏目副标题（中文）"/>
                            </a-form-item>

                    <a-form-item
                            :labelCol="labelCol"
                            :wrapperCol="wrapperCol"
                            label="英文副标题"
                            hasFeedback
                    >
                        <a-input v-decorator="['sname_en']"
                                 placeholder="English subtitle"/>
                    </a-form-item>


                    <a-form-item
                            :labelCol="labelCol"
                            :wrapperCol="wrapperCol"
                            label="图标"
                            hasFeedback
                    >
                        <pic-uploader
                                :file-list="formData.pic"
                        />
                    </a-form-item>
                    <!--        <a-form-item-->
                    <!--          :labelCol="labelCol"-->
                    <!--          :wrapperCol="wrapperCol"-->
                    <!--          label="广告图"-->
                    <!--          hasFeedback-->
                    <!--        >-->
                    <!--          <pic-uploader-->
                    <!--                :file-list="formData.banner"-->
                    <!--          />-->
                    <!--        </a-form-item>-->
                    <!--        <a-form-item-->
                    <!--          :labelCol="labelCol"-->
                    <!--          :wrapperCol="wrapperCol"-->
                    <!--          label="推荐位"-->
                    <!--          hasFeedback-->
                    <!--        >-->
                    <!--          <pic-uploader-->
                    <!--                :file-list="formData.recommend_pic"-->
                    <!--          />-->
                    <!--        </a-form-item>-->
                    <a-form-item
                            :labelCol="labelCol"
                            :wrapperCol="wrapperCol"
                            label="状态"
                            hasFeedback
                    >
                        <a-switch checkedChildren="显示" unCheckedChildren="隐藏" v-model="formData.status"/>
                    </a-form-item>
                    <a-form-item
                            v-if="formData.id"
                            :labelCol="labelCol"
                            :wrapperCol="wrapperCol"
                            label="排序"
                            hasFeedback
                    >
                        <a-input type="number" v-decorator="[
          'rank',
          {rules: [{ required: true, message: '请输入排序' }]}
        ]"
                                 placeholder="数字越小排名越靠前"/>
                    </a-form-item>

                </a-form>
            </a-spin>
            <template slot="footer">
                <a-button key="cancel" @click="handleCancel">取消</a-button>
                <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
            </template>
        </a-modal>

        <GoodsCateMemberDiscountForm :visible="memberVisible"
                                     :cateId="memberDiscountCateId"
                                     @memberDiscountDone="memberDiscountDone"></GoodsCateMemberDiscountForm>
    </a-card>
</template>

<script>
    import moment from 'moment'
    import EditableCell from '@/components/EditableCell/'
    import {getCateTreeList, editCate, addCate, deleteCate, getCateDetail, getCateList, setCateRank} from '@/api/goods'
    import PicUploader from '@/components/PicUploader/'
    import GoodsCateMemberDiscountForm from './GoodsCateMemberDiscountForm.vue'

    export default {
        name: 'GoodsCateList',
        components: {
            PicUploader, EditableCell, GoodsCateMemberDiscountForm
        },
        data() {
            return {
                saveLoading: false,
                visible: false,
                memberVisible: false,
//        description: '全校班级管理。',
                labelCol: {
                    xs: {span: 24},
                    sm: {span: 5},
                },
                wrapperCol: {
                    xs: {span: 24},
                    sm: {span: 12},
                },
                form: this.$form.createForm(this),
                mdl: {},

                // 高级搜索 展开/关闭
                advanced: false,
                // 查询参数
                queryParam: {},
                // 表头
                columns: [
                    {
                        title: '名称',
                        dataIndex: 'name',
                        scopedSlots: {customRender: 'name'},
                    },
                    {
                        title: '状态',
                        dataIndex: 'status',
                        scopedSlots: {customRender: 'status'},
                    },
                    {
                        title: '排序',
                        dataIndex: 'rank',
                        scopedSlots: {customRender: 'rank'},
                    },
                    {
                        table: '操作',
                        dataIndex: 'action',
                        width: '300px',
                        scopedSlots: {customRender: 'action'},
                    }
                ],
                // 加载数据方法 必须为 Promise 对象
                loadData: parameter => {
                    console.log('loadData');
                },
                treeList: [],
                cateList: [],
                formData: {
                    name: '',
                    name_en: '',
                    sname: '',
                    sname_en: '',
                    parents_ids: [],
                    id: 0,
                    pic: [],
                    recommend_pic: [],
                    banner: [],
                    status: true,
                },
                selectedRowKeys: [],
                selectedRows: [],
                memberDiscountCateId: 0,

            }
        },
        created() {
//      getRoleList({ t: new Date()})
        },
        computed: {
            options() {
                return this.treeList;
            }
        },
        mounted() {
            let that = this;
            that.fetch();
        },
        methods: {
            fetch() {
                let that = this;
                getCateTreeList()
                    .then(res => {
                        that.treeList = res.data
                    })
                getCateList()
                    .then(res => {
                        that.cateList = res.data
                    })
            },
            handleCancel() {
                this.visible = false
            },
            // 增
            handleAdd(record) {
                let that = this;
                that.visible = true;
                that.form.resetFields();
                that.formData = {
                    name: '',
                    name_en: '',
                    sname: '',
                    sname_en: '',
                    parents_ids: [],
                    id: 0,
                    pic: [],
                    recommend_pic: [],
                    banner: [],
                    status: true,
                }
                if (record.id) {
                    that.formData.parents_ids = that.cateParentsIds(record.id);
                    that.formData.parents_ids.push(record.id + '');
                }
                setTimeout(() => {
                    that.form.setFieldsValue({...that.formData});
                });
            },

            // 改
            handleEdit(record) {
                let self = this
                this.visible = true
//      this.form.resetFields();
                self.form.setFieldsValue({
                    name: '',
                    name_en: '',
                    sname: '',
                    sname_en: '',
                    rank: 0,
                });
                this.formData.id = record.id;
                getCateDetail({id: record.id}).then(res => {
                    setTimeout(() => {
                        self.form.setFieldsValue({...res.data});
                    }, 1)
                    self.formData.name = res.data.name;
                    self.formData.name_en = res.data.name_en || '';
                    self.formData.sname = res.data.sname;
                    self.formData.sname_en = res.data.sname_en || '';
                    self.formData.pic = res.data.pic;
                    self.formData.recommend_pic = res.data.recommend_pic;
                    self.formData.banner = res.data.banner;
                    self.formData.parents_ids = self.cateParentsIds(record.id);
                    self.formData.status = res.data.status == 1 ? true : false;
                })
                // console.log(this.mdl)
            },
            // 增改 处理
            handleOk(e) {
                let self = this
                e.preventDefault()
                this.form.validateFields((err, values) => {
                    if (!err) {
                        console.log('Received values of form: ', values)
                        console.log('Received valuess of formData: ', self.formData)
                        self.saveLoading = true;
                        if (self.formData.id) {
                            editCate(Object.assign(self.formData, values)).then(res => {
                                self.$message.success('修改成功')
                                self.fetch();
                                self.visible = false;
                                self.saveLoading = false;
                            }).catch(err => {
                                self.$message.error(err.data.msg);
                                self.saveLoading = false;
                            })
                        } else {
                            addCate(Object.assign(self.formData, values)).then(res => {
                                self.$message.success('新增成功')
                                self.fetch();
                                self.visible = false
                                self.saveLoading = false;
                            }).catch(err => {
                                self.$message.error(err.data.msg);
                                self.saveLoading = false;
                            })
                        }
                    }
                })
            },
            // 删
            deleteCate(record) {
                let self = this
                deleteCate({id: record.id}).then(res => {
                    self.$message.success('删除成功')
                    self.fetch();
                }).catch(err => {
                    self.$message.error(err.data.msg)
                })
            },

            // 显示会员优惠配置
            handleMemberDiscount(record) {
                let self = this
                self.memberDiscountCateId = record.id
                self.memberVisible = true
            },

            memberDiscountDone() {
                this.memberVisible = false
            },

            cateParentsIds(cate_id) {
                let self = this;
                let parent_id = cate_id;
                let parents_ids = [];
                while (parent_id != 0) {
                    cate_id = parent_id;
                    parent_id = self.getListParentId(cate_id);
                    if (parent_id > 0) {
                        parents_ids.push(parent_id + '');
                        continue;
                    }
                    break;
                }
                return parents_ids.reverse(parents_ids);
            },
            getListParentId(cate_id) {
                let self = this;
                let parent_id = 0;
                self.cateList.map(function (item) {
                    if (item.id == cate_id) {
                        parent_id = item.parent_id
                        return;
                    }
                })
                return parent_id;
            },

            onRankChange(key, dataIndex, value) {
                let self = this;
                setCateRank({
                    id: key,
                    rank: value
                }).then(res => {
                    self.fetch();
                }).catch(err => {
                    self.$message.error(err.data.msg)
                })
            },
        },
        watch: {
            /*
            'selectedRows': function (selectedRows) {
              this.needTotalList = this.needTotalList.map(item => {
                return {
                  ...item,
                  total: selectedRows.reduce( (sum, val) => {
                    return sum + val[item.dataIndex]
                  }, 0)
                }
              })
            }
            */
        }
    }
</script>